import { useInfiniteQuery } from "@tanstack/react-query";
import { ArticlesServiceImpl } from "../../domain/services/articlesService";
import { ArticlesResponse } from "../../data/models/article";

const ArticlesService = new ArticlesServiceImpl();

const useGetArticles = () => {
  const {
    data,
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
  } = useInfiniteQuery<ArticlesResponse>({
    queryKey: ["articles"],
    initialPageParam: 1,
    queryFn: ({ pageParam }) =>
      ArticlesService.getArticles(pageParam as number),
    getNextPageParam: (lastPage) => {
      const { page, pageCount } = lastPage.meta.pagination;
      return page < pageCount ? page + 1 : undefined;
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 10, // 10 minutes
    retry: 1,
  });
  return {
    data,
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    refetch,
    isFetchingNextPage,
  };
};

export default useGetArticles;
